import { render, staticRenderFns } from "./ProcessWorkPermitChoose.vue?vue&type=template&id=76854da1"
import script from "./ProcessWorkPermitChoose.vue?vue&type=script&lang=js"
export * from "./ProcessWorkPermitChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports